import React from 'react';
import { Outlet } from 'react-router-dom';
import { FooterConferencias, HeaderConferencias } from '@/components';

export const ConferenciasLayout = (): React.ReactElement => (
	<div className="o-layout">
		<HeaderConferencias />
		<div className="o-container u-mt-24">
			{/* <main className="o-layout__main"> */}
			<Outlet />
			{/* </main> */}
		</div>
		<FooterConferencias />
	</div>
);
